import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { CookiePolicyLink } from 'components/CookiePolicyLink'
import { PrivacyPolicyLink } from 'components/PrivacyPolicyLink'
import { TermsOfUseLink } from 'components/TermsOfUseLink'

import { getAppConfigMap } from 'helpers/getAppConfigMap'

import checkIcon from 'assets/images/sprite/check-light-green-icon.svg'

import { StyledWellnessFooter as S } from './WellnessFooter.styles'

export const WellnessFooter: React.FC = () => {
  const { t } = useTranslation()
  const { appConfig } = getAppConfigMap()

  return (
    <S.Wrapper>
      <S.Logo>{appConfig.displayName}</S.Logo>

      <S.Guarantee>
        <S.GuaranteeIcon svg={checkIcon} width={20} height={20} />
        {t('onboarding.landingWellness.footer.guarantee')}
      </S.Guarantee>

      <S.Disclaimer>
        <Trans i18nKey="onboarding.landingWellness.footer.disclaimer" />
      </S.Disclaimer>

      <S.Links>
        <TermsOfUseLink />
        <S.Separator />
        <PrivacyPolicyLink />
        <S.Separator />
        <CookiePolicyLink />
      </S.Links>

      <S.Copyright>
        {t('onboarding.landingWellness.footer.copyright', {
          year: new Date().getFullYear(),
          appName: appConfig.displayName,
        })}
      </S.Copyright>
    </S.Wrapper>
  )
}
